var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPasswordForm)?_c('div',{staticClass:"sign-in-text"},[_vm._v("\n  "+_vm._s(_vm.userString('signingInAsUserLabel', { user: _vm.username }))+"\n")]):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }